import React, { FC } from "react";
import { JCMSBanner, JCMSBannerProps } from "./../JCMSBanner";
import './JAdvertisement.scss';
export const JAdvertisement: FC<JCMSBannerProps> = props => {
    return (
        <div className="jbanner-border-radius jbanner-advertisement">
            <JCMSBanner
                {...props}
                leftSideAlign="left"
            />
        </div>
    )
}